import LocalStorageService from '@/services/localStorage.service'
import { PriceMapType } from '@/types/page'

export type PatreonObjectType = {
  currently_entitled_amount_cents: number
  full_name: string
  next_charge_date: string
  patron_status: string
}

export type UserStateType = {
  alternateArt?: Record<string, string[]>
  displayName: string
  email: string
  isAdmin?: boolean
  isStaff?: boolean
  namesUnderCards?: boolean
  patreon?: PatreonObjectType
  priceSources: Array<keyof PriceMapType>
  region?: string
  saltLevel?: number
  uid: string
  version: number
}

export const getUserInitialState = (): UserStateType => ({
  alternateArt: LocalStorageService.getJson('userState')?.alternateArt || null,
  displayName: '',
  email: '',
  isAdmin: false,
  isStaff: false,
  namesUnderCards: false,
  patreon: undefined,
  priceSources: ['cardkingdom', 'tcgplayer', 'face2face'],
  region: undefined,
  saltLevel: undefined,
  uid: '',
  version: 2,
})
